import { Component, OnInit, ViewEncapsulation, Inject, OnDestroy } from '@angular/core';
import { Router } from '@angular/router'
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { SiteService } from '../shared/services/site/site.service';
import { MapMarker } from '../shared/interface/map-marker';
import {  FormGroup, FormBuilder, Validators } from "@angular/forms";
import { DashboardService } from '../shared/services/dashboard/dashboard.service';
import { AclService } from '../shared/services/acl/acl.service';
import { UserService } from '../shared/services';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';


@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DashboardComponent implements OnInit , OnDestroy{
  private _unsubscribeAll  : Subject<any> = new Subject<any>();
  lat: number = 25.2048493;
  lng: number = 55.270782800000006;
  markers: MapMarker[] = [{
    _id: '',
    siteName: '',
    lat: 0,
    lng: 0
  }];
  activeSitesCount: any = 0;
  activeDevicesCount: any = 0;
  activeUsersCount: any = 0;


  constructor(
    private router: Router,
    public dialog: MatDialog,
    private dashboardService: DashboardService,
    private siteService: SiteService,
    private aclService: AclService
  ) {
  }

  ngOnInit() {
    //get the count of active devices,sites and users
    //where[isActive]=1&count=1 removed from filter as the api is not working with isActive filter
    this.dashboardService.siteCount().pipe(takeUntil(this._unsubscribeAll)).subscribe(res => {
      if (res && res.length != undefined)
        this.activeSitesCount = res.length;
      // if (res.count) {
      //   this.activeSitesCount = res.count;
      // }
      // this.activeSitesCount = res.count;
    });
    this.dashboardService.deviceCount().pipe(takeUntil(this._unsubscribeAll)).subscribe(res => {
      if (res.count) {
        this.activeDevicesCount = res.count;
      }
      // this.activeDevicesCount = res.count;
    });
    this.dashboardService.userCount().pipe(takeUntil(this._unsubscribeAll)).subscribe(res => {
      if (res.count) {
        this.activeUsersCount = res.count;
      }
      // this.activeUsersCount = res.count;
    });
    //get the site lat long
    this.siteService.list("fields=siteName,lat,lng").pipe(takeUntil(this._unsubscribeAll)).subscribe(res => {
      this.markers = <MapMarker[]><any>res;
    });
  }

  ngOnDestroy(){
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }

  openAddDashboardDialog = () => {
    this.dialog.open(AddDashboardDialog, {
      height: 'auto',
      width: '400px',
      minHeight: '200px',
      panelClass: 'full-modal'
    });
  };


  redirectToDevices() {
    if (!this.aclService.checkModuleAccess("devices:read")) {
      return false;
    }
    this.router.navigate(['profile'], { queryParams: { tab: 'devices' } });
  }

  redirectToSites() {
    if (!this.aclService.checkModuleAccess("sites:read")) {
      return false;
    }
    this.router.navigate(['profile'], { queryParams: { tab: 'sites' } });
  }

  redirectToUsers() {
    if (!this.aclService.checkModuleAccess("users:read")) {
      return false;
    }
    this.router.navigate(['profile'], { queryParams: { tab: 'users' } });
  }
}

//Add Edit dashboard dialog 
@Component({
  selector: 'add-dashboard-dialog',
  templateUrl: 'app-dashboard.dialog.html'
})
export class AddDashboardDialog {
  dashboardForm: FormGroup;
  isSubmitted: number = 0;
  private _unsubscribeAll  : Subject<any> = new Subject<any>();
  
  constructor(@Inject(MAT_DIALOG_DATA) public data: any, public fb: FormBuilder,
    private dashboardService: DashboardService, public dialogRef: MatDialogRef<AddDashboardDialog>,
    private userService: UserService) {
    this.createForm();
  }

  createForm() {
    this.dashboardForm = this.fb.group({
      dashboardName: ["", Validators.required],
      setDefaultDashboard: [false]
    });
  }

  //create dashboard form submit
  onSubmit(form: any) {
    this.isSubmitted = 1;
    form.setDefaultDashboard = (form.setDefaultDashboard) ? 1 : 0;

    this.dashboardService.create(form).pipe(takeUntil(this._unsubscribeAll)).subscribe(res => {
      this.dialogRef.close();
      this.isSubmitted = 0;

      //save dashboard default to profile
      let data = undefined;
      if (form.setDefaultDashboard) {
        data = { defaultDashboardName: form.dashboardName, defaultDashboard: res.data.dashboardId };
      }
      if (data) {
        this.userService.savePersonalDetailsToToken(data);
      }

      this.dashboardService.sendAction("deleteDashboard", "");
    }, (err) => {
      this.isSubmitted = 0;
    });
  }

  blockNumbers(evt) {
    evt = (evt) ? evt : window.event;
    var charCode = (evt.which) ? evt.which : evt.keyCode;
    if ((charCode > 64 && charCode < 91) || charCode == 8 || charCode == 32 || charCode == 189 || charCode == 37 || charCode == 39) {
      return true;
    }
    else {
      return false;
    }
  }
}




// WEBPACK FOOTER //
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/dashboard/dashboard.component.ts